module.exports = __webpack_public_path__ + "static/img/brief_up.05e1a98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brief_up.png
// module id = VVBg
// module chunks = 27